import {ChatEngine} from 'react-chat-engine'
import './App.css';
import ChatFeed from './components/ChatFeed';
import LoginForm from './components/LoginForm';


function App() {
	if(!localStorage.getItem('username')) return <LoginForm />


	return (
  

	<ChatEngine
			height='100vh'
			userName={localStorage.getItem('username')}
			userSecret={localStorage.getItem('password')}
			projectID='0d898a82-45ec-4542-8bd0-fb8eac7aa588'
  renderChatFeed={(chatAppProps) => <ChatFeed {...chatAppProps} />}
  
      />


  
  );
}

export default App;


